/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import api from "../api";

const qs = require("qs");

export default {
  state: {
    geofences: [],
    allGeofences: [],
    dataState: {
      scheduleLoad: "LOADING",
      scheduleError: null,
    },
    clientid: [],
  },
  getters: {
    getGeofencesData(state) {
      return state.geofences;
    },
    getAllGeofencesData(state) {
      return state.allGeofences;
    },
    getGeofenceByIdData(state) {
      return state.geofences;
    },
    getClientId(state) {
      return state.clientid;
    },
  },
  mutations: {
    SET_DATA_SCHEDULE({ dataState }, { state, error }) {
      dataState.scheduleLoad = state;
      dataState.scheduleError = error;
    },
    ADD_GEOFENCES_DATA(state, data) {
      state.geofences = data;
    },
    ADD_ALL_GEOFENCES_DATA(state, data) {
      state.allGeofences = data;
    },
    ADD_GEOFENCE_BY_ID_DATA(state, data) {
      state.geofences = data;
    },
    ADD_CLIENTID_DATA(state, data) {
      state.clientid = data;
    },
    ADD_ORIGIN(state, payload) {
      state.origin = payload;
    },
    ADD_ERROR(state, payload) {
      state.error = payload;
    },
    CLEAR_ERROR(state) {
      state.error = {
        code: null,
        message: null
      };
    }
  },
  actions: {
    GET_GEOFENCES({ commit, rootState }, payload) {
      const data = {
        token: rootState.token,
        clientid: rootState.clientid
      };
      if (payload && payload.hasOwnProperty("timezone")) {
        data.timezone = payload.timezone;
      }
      return api
        .post(
          `${process.env.VUE_APP_API_URL}/get_geofences`,
          qs.stringify(data)
        )
        .then((response) => {
          if (response !== null) {
            commit("ADD_GEOFENCES_DATA", response.data.data);
          }
        })
        .catch((error) => {
          const errorData = {
            state: "ERROR",
            error: error,
          };
          commit("SET_DATA_SCHEDULE", errorData);
        });
    },
    GET_ALL_GEOFENCES({ commit, rootState }, payload) {
      const data = {
        token: rootState.token,
      };
      if (payload && payload.hasOwnProperty("timezone")) {
        data.timezone = payload.timezone;
      }
      return api
        .post(
          `${process.env.VUE_APP_API_URL}/get_geofences`,
          qs.stringify(data)
        )
        .then((response) => {
          if (response !== null) {
            commit("ADD_ALL_GEOFENCES_DATA", response.data.data);
          }
        })
        .catch((error) => {
          const errorData = {
            state: "ERROR",
            error: error,
          };
          commit("SET_DATA_SCHEDULE", errorData);
        });
    },
    GET_GEOFENCE_BY_ID({ commit, rootState }, payloads) {
      return api
        .post(
          `${process.env.VUE_APP_API_URL}/get_geofence_by_id`,
          qs.stringify({
            token: rootState.token,
            id: payloads.id,
          })
        )
        .then((response) => {
          if (response !== null) {
            commit("ADD_GEOFENCE_BY_ID_DATA", response.data.data);
          }
        })
        .catch((error) => {
          const errorData = {
            state: "ERROR",
            error: error,
          };
          commit("SET_DATA_SCHEDULE", errorData);
        });
    },
    LOAD_CLIENTID({ commit, rootState }) {
      return api
        .post(
          `${process.env.VUE_APP_API_URL}/get_all_clientid`,
          qs.stringify({
            token: rootState.token,
          })
        )
        .then((response) => {
          if (response !== null) {
            commit("ADD_CLIENTID_DATA", response.data.data);
          }
        })
        .catch((error) => {
          const errorData = {
            state: "ERROR",
            error: error,
          };
          commit("SET_DATA_SCHEDULE", errorData);
        });
    }
  },
};
